import type { RouteObject } from "react-router-dom"
import ProtectedRoute from "@/components/auth/ProtectedRoute"
import HomePage from "@/pages/Home"
import DashboardPage from "@/pages/Dashboard"
import TenderDetailPage from "@/pages/TenderDetail"
import GrantsPage from "@/pages/Grants"
import GrantDetailPage from "@/pages/GrantDetail"
import ContactsPage from "@/pages/Contacts"
import SettingsPage from "@/pages/Settings"
import OutreachPage from "@/pages/Outreach"
import AiNewsPage from "@/pages/AiNews"
import LoginPage from "@/pages/Login"

export const routes: RouteObject[] = [
	{
		path: "/login",
		element: <LoginPage />,
	},
	{
		element: <ProtectedRoute />,
		children: [
			{ path: "/", element: <HomePage /> },
			{ path: "/dashboard", element: <DashboardPage /> },
			{ path: "/tenders/:id", element: <TenderDetailPage /> },
			{ path: "/grants", element: <GrantsPage /> },
			{ path: "/grants/:id", element: <GrantDetailPage /> },
			{ path: "/contacts", element: <ContactsPage /> },
			{ path: "/outreach", element: <OutreachPage /> },
			{ path: "/ai-news", element: <AiNewsPage /> },
			{ path: "/settings", element: <SettingsPage /> },
		],
	},
]
